// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts = require("./PropertyWizardFormRelay__Validators__KeyFacts.bs.js");
let PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardFormRelayValidators_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidators_formState_graphql.bs.js");
let PropertyWizardFormRelay__Validators__PhotosAndFiles = require("./PropertyWizardFormRelay__Validators__PhotosAndFiles.bs.js");
let PropertyWizardFormRelayValidators_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidators_localDraft_graphql.bs.js");

let Steps = {
  KeyFacts: undefined,
  MLSTiming: undefined,
  Description: undefined,
  Showings: undefined,
  PhotosAndFiles: undefined
};

let convertFragment = PropertyWizardFormRelayValidators_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidators_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidators_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidators_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidators_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayValidators_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidators_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidators_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidators_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidators_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsFormValid(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidators_localDraft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidators_formState_graphql.node, convertFragment$1, formState);
  let keyFactsValid = PropertyWizardFormRelay__Validators__KeyFacts.use(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let mlsTimingValid = PropertyWizardFormRelay__Validators__MLSTiming.use(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let descriptionValid = PropertyWizardFormRelay__Validators__Description.use(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let showingsValid = PropertyWizardFormRelay__Validators__Showings.use(draft$1.fragmentRefs);
  let photosAndFilesValid = PropertyWizardFormRelay__Validators__PhotosAndFiles.use(formState$1.fragmentRefs);
  if (keyFactsValid === "Invalid") {
    return {
      TAG: "Error",
      _0: "keyFacts"
    };
  }
  if (mlsTimingValid === "Valid") {
    if (descriptionValid === "Valid") {
      if (showingsValid === "Valid") {
        if (photosAndFilesValid === "Valid") {
          return {
            TAG: "Ok",
            _0: undefined
          };
        } else {
          return {
            TAG: "Error",
            _0: "photosAndFiles"
          };
        }
      } else if (showingsValid === "Invalid") {
        return {
          TAG: "Error",
          _0: "showings"
        };
      } else {
        return {
          TAG: "Error",
          _0: "photosAndFiles"
        };
      }
    }
  } else if (mlsTimingValid === "Invalid") {
    return {
      TAG: "Error",
      _0: "mlsTiming"
    };
  }
  if (descriptionValid === "Invalid") {
    return {
      TAG: "Error",
      _0: "description"
    };
  } else if (showingsValid === "Invalid") {
    return {
      TAG: "Error",
      _0: "showings"
    };
  } else {
    return {
      TAG: "Error",
      _0: "photosAndFiles"
    };
  }
}

let Utils;

exports.Utils = Utils;
exports.Steps = Steps;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.useIsFormValid = useIsFormValid;
/* RescriptRelay_Fragment Not a pure module */
